import React from "react";
import {
  HomeIcon,
  BriefcaseIcon,
  CalendarDaysIcon,
  BuildingStorefrontIcon,
  ClipboardDocumentListIcon,
  TruckIcon,
  BanknotesIcon,
  DocumentChartBarIcon,
  UsersIcon,
  UserGroupIcon,
  WrenchScrewdriverIcon,
  ArchiveBoxIcon,
  ChatBubbleLeftRightIcon,
  Cog8ToothIcon,
  DocumentArrowUpIcon,
  DocumentTextIcon,
  EnvelopeIcon,
  SparklesIcon,
  UserCircleIcon,
  RadioIcon,
} from "@heroicons/react/24/outline";

const FEATURE_ICON_MAP = {
  dashboard: HomeIcon,
  jobs: BriefcaseIcon,
  dispatch: RadioIcon,
  clients: BuildingStorefrontIcon,
  manifests: ClipboardDocumentListIcon,
  calendar: CalendarDaysIcon,
  invoices: BanknotesIcon,
  payouts: DocumentArrowUpIcon,
  reports: DocumentChartBarIcon,
  users: UsersIcon,
  employees: UserGroupIcon,
  drivers: TruckIcon,
  equipment: WrenchScrewdriverIcon,
  inventory: ArchiveBoxIcon,
  feedback: ChatBubbleLeftRightIcon,
  "settings-general": Cog8ToothIcon,
  "settings-rates": BanknotesIcon,
  "settings-users": UsersIcon,
  "settings-billing": BanknotesIcon,
  "settings-features": SparklesIcon,
  "settings-templates": DocumentTextIcon,
  "settings-task-templates": ClipboardDocumentListIcon,
  "settings-notification-templates": ChatBubbleLeftRightIcon,
  "settings-reports": DocumentChartBarIcon,
  "settings-email": EnvelopeIcon,
  "settings-dispatch": ClipboardDocumentListIcon,
  "settings-advanced": Cog8ToothIcon,
  "account-settings": UserCircleIcon,
};

export function getFeatureIcon(featureId, className = "h-4 w-4") {
  const Icon = FEATURE_ICON_MAP[featureId] || DocumentTextIcon;
  return <Icon className={className} />;
}

